import { Capacitor } from '@capacitor/core';
import { ModalController } from '@ionic/angular';
import { NotAvailableComponent } from '@shared/components/not-available/not-available.component';

/**
 * Helper function para detectar o link de download baseado no app
 */
function getDownloadLink(): string {
  // Tenta acessar o environment através do window (se disponível)
  if (typeof window !== 'undefined' && (window as any).environment?.adjustDownloadLink) {
    return (window as any).environment.adjustDownloadLink;
  }
  
  // Detecta pelo mainServer ou URL
  const url = typeof window !== 'undefined' ? window.location.href : '';
  if (url.includes('veggly') || url.includes('veggly-v3')) {
    return 'https://app.adjust.com/106z1xo9'; // Veggly
  }
  
  // Default para Flamr
  return 'https://app.adjust.com/12vohm6r'; // Flamr
}

/**
 * Decorator de método que impede a execução da função se a plataforma for 'web'.
 * Exibe um aviso no console e retorna uma Promise resolvida para métodos assíncronos
 * para não quebrar a cadeia de chamadas.
 */
export function WebBlocker() {
  // Retorna o decorator real
  return function (
    target: Object,
    propertyKey: string,
    descriptor: PropertyDescriptor
  ) {

    const originalMethod = descriptor.value;
    descriptor.value = async function(...args: any[]) {

      // Verifica se a plataforma é web
      if (Capacitor.getPlatform() === 'web') {
        console.warn(
          `[Acesso Bloqueado] A função '${propertyKey}' não está disponível na versão web.`
        );

        const modalCtrl = (this as any).modalCtrl as ModalController;
        
        // Tenta obter o link do environment através do contexto do componente
        let downloadLink = getDownloadLink();
        if ((this as any).environment?.adjustDownloadLink) {
          downloadLink = (this as any).environment.adjustDownloadLink;
        }

        const modal = await modalCtrl.create({
          component: NotAvailableComponent,
          componentProps: {
            downloadLink: downloadLink
          },
          cssClass: 'custom-class-modal',
          backdropDismiss: true
        });
      
        await modal.present();
        await modal.onDidDismiss();

        // Para funções async, retorna uma Promise resolvida para evitar erros.
        const isAsync = originalMethod.constructor.name === 'AsyncFunction';
        if (isAsync) {
          return Promise.resolve();
        }
        // Para funções síncronas, simplesmente retorna.
        return;
      } else {
        // Se não for web, executa a função original normalmente
        return originalMethod.apply(this, args);
      }
    };

    return descriptor;
  }
}